import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo, useState } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Tooltip } from '../../Feedback/Tooltip';
import { Dropdown, DropdownWithFilterState } from './components/Dropdown';
import { FilterButton } from './components/FilterButton';
import { AUTOFOCUS_WITHOUT_SCROLL } from './components/Search';
import { SelectedLabel } from './components/SelectedLabel';
import { DEFAULT_DROPDOWN_WIDTH } from './constants';
const Component = (props) => {
    const { dropdownAlign, label, isEnabledSelectedLabel = true, dataTestId, serverSideFiltering, options, formatOptionLabel, dropdownWidth = DEFAULT_DROPDOWN_WIDTH, ...restProps } = props;
    const { isMulti, selected, disabled, recover } = restProps;
    const [isShown, setIsShown] = useState(false);
    const selectedOptions = useMemo(() => {
        if (isMulti) {
            return selected;
        }
        return selected ? [selected] : [];
    }, [isMulti, selected]);
    const handleClose = useCallbackRef(() => {
        setIsShown(false);
    });
    const serverSideFilteringProps = useMemo(() => {
        if (!serverSideFiltering)
            return null;
        return {
            serverSideFiltering,
            filter: serverSideFiltering.filter,
            setFilter: serverSideFiltering.setFilter,
            total: serverSideFiltering.total,
        };
    }, [serverSideFiltering]);
    const commonDropdownProps = useMemo(() => ({
        ...restProps,
        close: handleClose,
        formatOptionLabel,
        dataTestId: 'dropdown-body',
        dropdownWidth,
    }), [restProps, handleClose, formatOptionLabel, dropdownWidth]);
    const dropdownComponent = useMemo(() => {
        if (serverSideFilteringProps) {
            return _jsx(Dropdown, { ...commonDropdownProps, ...serverSideFilteringProps, filteredOptions: options, options: options });
        }
        return _jsx(DropdownWithFilterState, { ...commonDropdownProps, options: options });
    }, [serverSideFilteringProps, commonDropdownProps, options]);
    const buttonContent = useMemo(() => {
        if (selectedOptions.length && isEnabledSelectedLabel) {
            return _jsx(SelectedLabel, { selected: selectedOptions, label: label, formatOptionLabel: formatOptionLabel });
        }
        return label;
    }, [selectedOptions, isEnabledSelectedLabel, label, formatOptionLabel]);
    return (_jsx(FilterButton, { isShown: isShown, setIsShown: setIsShown, disabled: disabled, align: dropdownAlign, recover: recover, dropdownWidth: dropdownWidth, dropdown: dropdownComponent, dataTestId: dataTestId, children: buttonContent }));
};
const Filter = memo(function Filter(props) {
    const { tooltip, autofocus = AUTOFOCUS_WITHOUT_SCROLL, ...componentProps } = props;
    const componentWithAutofocus = useMemo(() => _jsx(Component, { ...componentProps, autofocus: autofocus }), [componentProps, autofocus]);
    if (tooltip) {
        return (_jsx(Tooltip, { tooltip: tooltip, placement: 'top', children: _jsx(Component, { ...componentProps, autofocus: autofocus }) }));
    }
    return componentWithAutofocus;
});
export default Filter;
